var map = {
	"./fearlesscities.svg": 52721,
	"./icon-bcnencomu.png": 12618,
	"./logo-bcnencomu.png": 25364,
	"./platoniq-logo.svg": 35473,
	"./texture-blue.jpg": 1552,
	"./texture-red.jpg": 5175,
	"./texture-yellow.jpg": 36660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;